module.exports = __webpack_public_path__ + "static/img/图片3.af0d325b.png";